export default __webpack_public_path__ + "static/cta-arrow-3-34eb7b6e8912cf705a46b792ba3a45bb.png";